import { Component, inject, signal } from "@angular/core";
import { ROUTES } from "../../../../constants/routes";
import { Router, RouterLink } from "@angular/router";
import { email, form, FormField, required, submit } from "@angular/forms/signals";
import { AccountPageWrapper } from "../../components/account-page-wrapper/account-page-wrapper";
import { PasswordInput } from "../../../../components/password-input/password-input";
import { AccountService } from "../../../../services/account.service";
import { AuthService } from "../../../../services/auth.service";
import { ClientResponse } from "../../../../models/api-response.model";
import { LoginResponse } from "../../../../models/account/login.model";

interface LoginModel {
  email: string;
  password: string;
}

@Component({
  selector: "app-login",
  imports: [FormField, RouterLink, AccountPageWrapper, PasswordInput],
  templateUrl: "./login.html",
  styleUrl: "./login.scss"
})
export class Login {
  readonly routes = ROUTES;
  private readonly _accountService = inject(AccountService);
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);

  readonly model = signal<LoginModel>({ email: "", password: "" });

  readonly loginForm = form(this.model, f => {
    required(f.email, { message: "Email is required." });
    required(f.password, { message: "Password is required." });
  });

  async onSubmit(event: Event): Promise<void> {
    event.preventDefault();

    await submit(this.loginForm, async () => {
      const { email, password } = this.model();

      return new Promise<void>(resolve => {
        this._accountService.login({ email, password }).subscribe((response: ClientResponse<LoginResponse>) => {
          if (response.isSuccess) {
            this._authService.storeTokens(response.data);
            const returnUrl = this._authService.consumeReturnUrl();
            void this._router.navigateByUrl(returnUrl);
          }

          resolve();
        });
      });
    });
  }
}
